import React, { useEffect, useState } from "react";
import { Loader2, ScrollText } from "lucide-react";
import api from "../lib/api";
import { matchesQuery } from "../lib/search";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";

const ACTION_BADGE = {
  login: "bg-primary/15 text-primary", login_failed: "bg-destructive/15 text-destructive",
  create: "bg-primary/15 text-primary", edit: "bg-amber-500/15 text-amber-600",
  delete: "bg-destructive/15 text-destructive", logout: "bg-muted text-muted-foreground",
};

function fmt(ts) {
  try { return new Date(ts).toLocaleString("es-GT", { dateStyle: "short", timeStyle: "short" }); }
  catch { return ts; }
}

export default function AuditPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/audit").then((r) => setLogs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = logs.filter((l) =>
    matchesQuery([l.username, l.module, l.action, l.record], q)
  );

  return (
    <div className="space-y-5">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">Registro de acciones importantes del sistema (últimos 300 eventos).</p>
        <Input data-testid="audit-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar en auditoría..." className="rounded-sm w-full sm:w-72" />
      </div>

      <Card className="rounded-sm border shadow-none overflow-hidden">
        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
        ) : filtered.length === 0 ? (
          <div className="flex flex-col items-center py-16 text-muted-foreground">
            <ScrollText className="h-8 w-8 mb-2" /><p className="text-sm">Sin registros.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="audit-table">
              <thead>
                <tr className="bg-muted text-left text-xs uppercase tracking-widest text-muted-foreground">
                  <th className="px-4 py-3 font-bold">Fecha</th>
                  <th className="px-4 py-3 font-bold">Usuario</th>
                  <th className="px-4 py-3 font-bold">Módulo</th>
                  <th className="px-4 py-3 font-bold">Acción</th>
                  <th className="px-4 py-3 font-bold">Registro</th>
                  <th className="px-4 py-3 font-bold">IP</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((l) => (
                  <tr key={l.id} className="border-t border-border hover:bg-muted/50 transition-colors">
                    <td className="px-4 py-2.5 font-mono text-xs whitespace-nowrap">{fmt(l.created_at)}</td>
                    <td className="px-4 py-2.5 font-medium">@{l.username}</td>
                    <td className="px-4 py-2.5 text-muted-foreground">{l.module}</td>
                    <td className="px-4 py-2.5">
                      <span className={`inline-block px-2 py-0.5 rounded-sm text-[11px] font-bold uppercase ${ACTION_BADGE[l.action] || "bg-muted text-muted-foreground"}`}>{l.action}</span>
                    </td>
                    <td className="px-4 py-2.5 font-mono text-xs">{l.record || "—"}</td>
                    <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground">{l.ip || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
